/**
 *  Component - Radio
 *
 *  @param { label } Radio button label
 *  @param { name } radio group name
 *  @param { id } radio button id
 *  @param { value } value for selected radio
 *
 * Usage:
 * <!--
 *  <div class="radio-btn">
 *    <tl-radio name="gender" label="Male" id="gender1" value="male" v-model="gender" />
 *    <tl-radio name="gender" label="Female" id="gender2" value="female" v-model="gender" />
 *    <tl-radio name="gender" label="Prefer not to tell" id="gender3" value="other" v-model="gender" />
 *  </div>
 *   -->
 *
 */

 /*
Author: Vaishnavi
Date: 27/11/2019
Issue Description: Checkbox text color changed to #444 (line no. 80)
*/
<template>
  <div>
    <input type="radio"  :id="id" :name="name"  :value="value" :ref="reference"
      @change="$emit('change', $event.target.value)" :checked="checked==value">
    <label class="label" :for="id">{{ label }}</label>
  </div>
</template>

<script>
export default {
  model: {
    prop: "checked",
    event: "change"
  },
  props: {
    label: {
      type: String
    },
    name: {
      type: String
    },
    reference: {
      type: String
    },
    id: {
      type: String
    },
    value: {
      type: String | Boolean
    },
    checked:{
      type: String | Boolean
    }
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
[type="radio"]:checked,
[type="radio"]:not(:checked) {
    position: absolute;
    left: -9999px;
}
[type="radio"]:checked + label,
[type="radio"]:not(:checked) + label
{
    position: relative;
    padding-left: 20px;
    cursor: pointer;
    line-height: 15px;
    display: inline-block;
    margin-right: 8px;
    color: #444;
    margin-right: 56px;
}
[type="radio"]:checked + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 14px;
    height: 14px;
    border: 1px solid #34c0be;
    border-radius: 100%;
    background: #fff;
}
[type="radio"]:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 14px;
    height: 14px;
    border: 1px solid #ddd;
    border-radius: 100%;
    background: #fff;
}
[type="radio"]:checked + label:after,
[type="radio"]:not(:checked) + label:after {
    content: '';
    width: 8px;
    height: 8px;
    background: #34c0be;
    position: absolute;
    top: 3px;
    left: 3px;
    border-radius: 100%;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
}
[type="radio"]:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
}
[type="radio"]:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
}
.label {
  font-size: 14px;
}
</style>
